/**
 * @flow
 * @relayHash b7f21af9c8093acbfb121de5748f9e18
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MapRoomEmbedRootUserQueryVariables = {||};
export type MapRoomEmbedRootUserQueryResponse = {|
  +currentUser: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +jsonid: ?string,
        +username: ?string,
        +userFirstName: string,
        +userReportName: string,
        +userImage: ?{|
          +url: ?string
        |},
      |}
    |}>
  |}
|};
export type MapRoomEmbedRootUserQuery = {|
  variables: MapRoomEmbedRootUserQueryVariables,
  response: MapRoomEmbedRootUserQueryResponse,
|};
*/


/*
query MapRoomEmbedRootUserQuery {
  currentUser {
    edges {
      node {
        jsonid
        username
        userFirstName
        userReportName
        userImage {
          url
          id
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "jsonid",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "userFirstName",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "userReportName",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "MapRoomEmbedRootUserQuery",
  "id": null,
  "text": "query MapRoomEmbedRootUserQuery {\n  currentUser {\n    edges {\n      node {\n        jsonid\n        username\n        userFirstName\n        userReportName\n        userImage {\n          url\n          id\n        }\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MapRoomEmbedRootUserQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "currentUser",
        "storageKey": null,
        "args": null,
        "concreteType": "UserAccountNodeConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserAccountNodeEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserAccountNode",
                "plural": false,
                "selections": [
                  v0,
                  v1,
                  v2,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userImage",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProfileImageNode",
                    "plural": false,
                    "selections": [
                      v4
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MapRoomEmbedRootUserQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "currentUser",
        "storageKey": null,
        "args": null,
        "concreteType": "UserAccountNodeConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserAccountNodeEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserAccountNode",
                "plural": false,
                "selections": [
                  v0,
                  v1,
                  v2,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userImage",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProfileImageNode",
                    "plural": false,
                    "selections": [
                      v4,
                      v5
                    ]
                  },
                  v5
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2daa2bf27b381f8de28a55d2c50bda54';
module.exports = node;



// WEBPACK FOOTER //
// ./src/components/Root/__generated__/MapRoomEmbedRootUserQuery.graphql.js